import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { EssorButton } from '../index';
import { ExtendProps } from '../essorButton';

const EditButton: FunctionComponent<ExtendProps> = ({ label, ...others }) => {
  const { t } = useTranslation();
  return (
    <EssorButton type="edit" size="tiny" {...others}>
      {label || t('edit')}
    </EssorButton>
  );
};

EditButton.defaultProps = {
  disabled: false,
  floated: undefined,
  label: undefined,
};

export default EditButton;
